import {
  EscalationLevel,
  EscalationSeverity,
  type EscalationSeverity as EscalationSeverityValue,
  type EscalationTone,
} from "@playbookai/widget-schemas";
export const severities = EscalationSeverity.options;
export const levels = EscalationLevel.options;
export const severityClass: Record<EscalationSeverityValue, string> = {
  High: "text-pb-red-text",
  Medium: "text-pb-amber-text",
  Low: "text-pb-text-muted",
};
export const toneClass: Record<EscalationTone, string> = {
  neutral: "border-pb-border bg-pb-card-elevated/30",
  watch: "border-pb-amber/30 bg-pb-amber/5",
  warn: "border-pb-amber/50 bg-pb-amber/10",
  critical: "border-pb-red/40 bg-pb-red/10",
};
